import { sendEvent, SendEventConfig } from 'api/play';
import { useMutation, UseMutationOptions } from 'react-query';

export default function useSendApiEvent(
  config?: Omit<
    UseMutationOptions<void, unknown, SendEventConfig, unknown>,
    'mutationFn'
  >,
) {
  return useMutation(sendEvent, config);
}
